<script setup>
import { VDataTable } from "vuetify/labs/VDataTable";
import AppSelect from "@core/components/app-form-elements/AppSelect.vue";
import { withQuery } from "ufo";

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Parameter Setting System";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "System",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];
const headers = [
  {
    title: "No",
    sortable: false,
    key: "no",
  },
  {
    title: "Paramater No",
    key: "parameterNo",
  },
  {
    title: "Name",
    key: "name",
  },
  {
    title: "Key",
    key: "key",
  },
  {
    title: "Value",
    key: "value",
  },
  {
    title: "Description",
    key: "description",
  },
  {
    title: "Actions",
    sortable: false,
    key: "actions",
  },
];

const form = ref({
  name: null,
});

const { data: dataQueries } = await useApi(
  withQuery("/cms/parameter", {
    page: 0,
  })
);

const query = dataQueries
  ? dataQueries.value
    ? dataQueries.value?.data
    : []
  : [];

const data = [];

let increment = 1;
query.forEach((item, index) => {
  const inc = { no: increment++ };
  const allValues = { ...inc, ...item };
  data.push(allValues);
});

const dataItems = ref([]);

const options = ref({
  page: 1,
  itemsPerPage: 5,
  sortBy: [""],
  sortDesc: [false],
});

const perPages = [5, 10, 25, 50];

onMounted(() => {
  dataItems.value = JSON.parse(JSON.stringify(data));
});
const resetInput = () => {
  //
};

const categories = [
  {
    title: "Locale",
    value: "1",
  },
  {
    title: "eMoney",
    value: "2",
  },
  {
    title: "System Control",
    value: "3",
  },
  {
    title: "Terminal Handling",
    value: "4",
  },
];

const subCategories = [
  {
    title: "Country",
    value: "1",
  },
  {
    title: "Date Format",
    value: "2",
  },
  {
    title: "Currency Setup",
    value: "3",
  },
  {
    title: "Others",
    value: "4",
  },
];

const subCategoriesExtra = [
  {
    title: "Common information /number of data for each page",
    value: "1",
  },
  {
    title: "For Issuers",
    value: "2",
  },
  {
    title: "For Merchant",
    value: "3",
  },
  {
    title: "For Card Holder",
    value: "4",
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">Data {{ pageTitle }}</h4>
  <VCard>
    <VDataTable
      :headers="headers"
      :items="dataItems"
      :items-per-page="options.itemsPerPage"
      :options="options"
      :page="options.page"
      :search="form.name"
      class="py-5"
    >
      <template #top>
        <!--        <VForm ref="refForm" @submit.prevent="() => {}">
                  <VRow class="ms-4 me-4 my-2 justify-center justify-sm-space-between">
                    <VCol cols="24" lg="12" sm="12">
                      <div class="d-flex flex-rows gap-4">
                        <AppSelect
                          :items="categories"
                          clearable
                          placeholder="Choose Category"
                        />
                        <AppSelect
                          :items="subCategories"
                          clearable
                          placeholder="Choose Sub Category"
                        />
                        <AppSelect
                          :items="subCategoriesExtra"
                          clearable
                          placeholder="Choose Sub Category Extra"
                        />
                      </div>
                    </VCol>
                    <VCol cols="24" lg="4" sm="4">
                      <AppTextField clearable placeholder="Input Words" />
                    </VCol>
                  </VRow>
        
                  <div
                    class="ms-4 me-4 my-2 d-flex flex-col justify-center text-center justify-sm-space-center gap-6"
                  >
                    <VBtn color="primary"> Search</VBtn>
                    <VBtn color="secondary" type="reset" @click="resetInput">
                      <VIcon icon="tabler-refresh" start />
                      Clear
                    </VBtn>
                  </div>
                </VForm>-->
        <VRow class="ms-4 me-4 my-2 justify-end justify-sm-space-end">
          <VCol cols="12" lg="10" sm="10">
            <AppTextField
              v-model="form.name"
              clearable
              placeholder="Input Words"
            />
          </VCol>
          <VCol cols="12" lg="2" sm="2">
            <AppSelect
              v-model="options.itemsPerPage"
              :items="perPages"
              class="w-50 ml-auto"
              placeholder="Per Page"
            />
          </VCol>
        </VRow>
      </template>
      <template #item.id="{ item }">{{ increment++ }}</template>
      <template #item.actions="{ item }">
        <div class="d-flex gap-1">
          <IconBtn :to="{ path: 'parameter-setting-system/view/' + item.id }">
            <VIcon icon="tabler-edit" />
          </IconBtn>
        </div>
      </template>
      <template #bottom>
        <VCardText class="pt-2">
          <div
            class="d-flex flex-wrap justify-center justify-sm-space-between gap-y-2 mt-2"
          >
            <div></div>
            <VPagination
              v-model="options.page"
              :length="Math.ceil(dataItems.length / options.itemsPerPage)"
              :total-visible="$vuetify.display.smAndDown ? 3 : 5"
            />
          </div>
        </VCardText>
      </template>
    </VDataTable>
  </VCard>
</template>
